module.exports = __webpack_public_path__ + "static/media/chocolat_bar.e71024bd.png";